import Layout from '@/layout'
const asyncConsumablesManagementRoutes =
{
  path: '/stock/consumablesManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '耗材管理',
  funcPerms: 'stock:consum',
  alwaysShow: true, // 只有一个子菜单时显示父菜单
  meta: {
    title: '耗材管理',
    icon: 'consum',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'consumables/inventoryQuery',
      component: () => import('@/views/oa/consumablesManagement/inventoryQuery/index'),
      funcPerms: 'stock:consum:stock:query',
      name: 'consumablesInventoryQuery',
      meta: {
        title: '库存查询',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: 'consumables/purchasePlan',
    //   component: () => import('@/views/oa/consumablesManagement/purchasePlan/index'),
    //   funcPerms: 'oa:consum:purchasePlan',
    //   name: 'purchasePlan',
    //   meta: {
    //     title: '耗材采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchasePlan/view',
    //   component: () => import('@/views/oa/consumablesManagement/purchasePlan/view'),
    //   funcPerms: 'oa:consum:purchasePlan:view',
    //   name: 'purchasePlanView',
    //   hidden: true,
    //   meta: {
    //     title: '查看耗材采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchasePlanviewSummary',
    //   component: () => import('@/views/oa/consumablesManagement/purchasePlan/viewSummary'),
    //   funcPerms: 'oa:consum:purchasePlan:viewSummary',
    //   name: 'purchaseviewSummary',
    //   hidden: true,
    //   meta: {
    //     title: '查看汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchasePlan/detail',
    //   component: () => import('@/views/oa/consumablesManagement/purchasePlan/detail'),
    //   funcPerms: 'oa:consum:purchasePlan:detail',
    //   name: 'purchasePlanDetail',
    //   hidden: true,
    //   meta: {
    //     title: '查看明细',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchasePlan/submitReview',
    //   component: () => import('@/views/oa/consumablesManagement/purchasePlan/submitReview'),
    //   funcPerms: 'oa:consum:purchasePlan:submitReview',
    //   name: 'purchasePlan-submitReview',
    //   hidden: true,
    //   meta: {
    //     title: '提交审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchase',
    //   component: () => import('@/views/oa/consumablesManagement/purchase/index'),
    //   funcPerms: 'oa:consum:purchaseApply',
    //   name: 'consumablesPurchase',
    //   meta: {
    //     title: '耗材采购',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchase/add',
    //   component: () => import('@/views/oa/consumablesManagement/purchase/add'),
    //   funcPerms: 'oa:consum:purchaseApply:add',
    //   name: 'ConsumablesPurchaseApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'consumables/purchase/edit',
    //   component: () => import('@/views/oa/consumablesManagement/purchase/add'),
    //   funcPerms: 'oa:consum:purchaseApply:edit',
    //   name: 'ConsumablesPurchaseApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'consumables/purchase/view',
    //   component: () => import('@/views/oa/consumablesManagement/purchase/view'),
    //   funcPerms: 'oa:consum:purchaseApply:view',
    //   name: 'consumablesPurchaseApplication-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'consumables/purchaseReview',
    //   component: () => import('@/views/oa/consumablesManagement/purchaseReview/index'),
    //   funcPerms: 'oa:consum:purchaseReview',
    //   name: 'purchaseReview',
    //   meta: {
    //     title: '耗材采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'consumables/purchaseReview/view',
    //   component: () => import('@/views/oa/consumablesManagement/purchaseReview/view'),
    //   funcPerms: 'oa:consum:purchaseReview:view',
    //   name: 'purchaseReview-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看耗材采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesApplication',
    //   component: () => import('@/views/oa/consumablesManagement/reagentApplication/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesApplication',
    //   meta: {
    //     title: '耗材申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesApplicationAdd',
    //   component: () => import('@/views/oa/consumablesManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增耗材申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesApplicationEdit',
    //   component: () => import('@/views/oa/consumablesManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑耗材申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesApplicationView',
    //   component: () => import('@/views/oa/consumablesManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesApplicationView',
    //   hidden: true,
    //   meta: {
    //     title: '查看耗材申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesWarehouserVerify',
    //   component: () => import('@/views/oa/consumablesManagement/warehouserVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesWarehouserVerify',
    //   meta: {
    //     title: '库管审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesWarehouserVerify/view',
    //   component: () => import('@/views/oa/consumablesManagement/warehouserVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesWarehouserVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '库管审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDepttHeaderVerify',
    //   component: () => import('@/views/oa/consumablesManagement/depttHeaderVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDepttHeaderVerify',
    //   meta: {
    //     title: '科主任审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDepttHeaderVerify/view',
    //   component: () => import('@/views/oa/consumablesManagement/depttHeaderVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDepttHeaderVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '科主任审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDepttHeaderSummary',
    //   component: () => import('@/views/oa/consumablesManagement/depttHeaderSummary/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDepttHeaderSummary',
    //   meta: {
    //     title: '科主任汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDepttHeaderSummary/view',
    //   component: () => import('@/views/oa/consumablesManagement/depttHeaderSummary/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDepttHeaderSummaryView',
    //   hidden: true,
    //   meta: {
    //     title: '科主任汇总详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesFinanceVerify',
    //   component: () => import('@/views/oa/consumablesManagement/financeVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesFinanceVerify',
    //   meta: {
    //     title: '财务审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesFinanceVerify/view',
    //   component: () => import('@/views/oa/consumablesManagement/financeVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesFinanceVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '财务审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesAffairsDeptVerify',
    //   component: () => import('@/views/oa/consumablesManagement/affairsDeptVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesAffairsDeptVerify',
    //   meta: {
    //     title: '总务科审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesAffairsDeptVerify/view',
    //   component: () => import('@/views/oa/consumablesManagement/affairsDeptVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesAffairsDeptVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '总务科审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesStorage',
    //   component: () => import('@/views/oa/consumablesManagement/reagentStorage/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesStorage',
    //   meta: {
    //     title: '耗材入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesStorage/add',
    //   component: () => import('@/views/oa/consumablesManagement/reagentStorage/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesStorageAdd',
    //   hidden: true,
    //   meta: {
    //     title: '入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesOutbound',
    //   component: () => import('@/views/oa/consumablesManagement/reagentOutbound/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesOutbound',
    //   meta: {
    //     title: '耗材出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesOutbound/out',
    //   component: () => import('@/views/oa/consumablesManagement/reagentOutbound/out'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesOutboundOut',
    //   hidden: true,
    //   meta: {
    //     title: '出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesOutbound/view',
    //   component: () => import('@/views/oa/consumablesManagement/reagentOutbound/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesOutboundView',
    //   hidden: true,
    //   meta: {
    //     title: '出库详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDeptManagerStorage',
    //   component: () => import('@/views/oa/consumablesManagement/deptManagerStorage/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDeptManagerStorage',
    //   meta: {
    //     title: '科室库管入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDeptManagerStorage/view',
    //   component: () => import('@/views/oa/consumablesManagement/deptManagerStorage/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDeptManagerStorageView',
    //   hidden: true,
    //   meta: {
    //     title: '科室库管入库详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'consumables/inventoryDetails',
      component: () => import('@/views/oa/consumablesManagement/inventoryDetails/index'),
      funcPerms: 'stock:consum:stockin:detail',
      name: 'inventoryDetails',
      meta: {
        title: '入库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'consumables/OutboundDetail',
      component: () => import('@/views/oa/consumablesManagement/OutboundDetail/index'),
      funcPerms: 'stock:consum:stockout:detail',
      name: 'OutboundDetail',
      meta: {
        title: '出库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'consumables/deptUseApply',
      component: () => import('@/views/oa/consumablesManagement/deptUseApply/index'),
      funcPerms: 'stock:consum:useApply',
      name: 'consumablesDeptUseApply',
      meta: {
        title: '使用申领',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'consumables/deptUseApply/query',
      component: () => import('@/views/oa/consumablesManagement/deptUseApply/query'),
      funcPerms: 'stock:hr:manager',
      name: 'consumablesDeptUseApplyQuery',
      hidden: true,
      meta: {
        title: '查询库存',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/consumablesDeptUseApply/edit',
    //   component: () => import('@/views/oa/consumablesManagement/deptUseApply/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDeptUseApplyEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑申领',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesDeptUseApply/view',
    //   component: () => import('@/views/oa/consumablesManagement/deptUseApply/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDeptUseApplyView',
    //   hidden: true,
    //   meta: {
    //     title: '申领详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'consumables/deptUseApplyVerify',
      component: () => import('@/views/oa/consumablesManagement/deptUseApplyVerify/index'),
      funcPerms: 'stock:consum:applyAudit',
      name: 'consumablesDeptUseApplyVerify',
      meta: {
        title: '申领审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/consumablesDeptUseApplyVerify/view',
    //   component: () => import('@/views/oa/consumablesManagement/deptUseApplyVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesDeptUseApplyVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '使用申领审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'consumables/inventoryImport',
      component: () => import('@/views/oa/consumablesManagement/inventoryImport/index'),
      funcPerms: 'stock:consum:stockImport',
      name: 'consumablesInventoryImport',
      meta: {
        title: '库存导入',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
    // {
    //   path: '/consumablesStoragePlace',
    //   component: () => import('@/views/oa/consumablesManagement/storagePlace/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesStoragePlace',
    //   meta: {
    //     title: '存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesStoragePlace/add',
    //   component: () => import('@/views/oa/consumablesManagement/storagePlace/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesStoragePlaceAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/consumablesStoragePlace/edit',
    //   component: () => import('@/views/oa/consumablesManagement/storagePlace/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'consumablesStoragePlaceEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // }
  ]
}

export default asyncConsumablesManagementRoutes
